import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCalendar, FaArrowRight, FaBolt, FaWater, FaHammer, FaFire, FaWind, FaPaintBrush, FaShieldAlt } from 'react-icons/fa';
import './BlogIndex.css';
import CallToAction from '../../components/CallToAction';
function BlogIndex() {
  const [searchTerm, setSearchTerm] = useState('');
  const [email, setEmail] = useState('');

  const blogs = [
    {
      id: 1,
      title: 'Professional Electricians Qatar: Expert MEP Solutions & Skilled Manpower Supply',
      excerpt: 'Certified electricians in Qatar providing manpower supply, MEP systems installation, and 24/7 emergency electrical repairs.',
      date: 'January 15, 2025',
      category: 'Electricians',
      slug: 'electricians-qatar',
      keywords: ['Electricians Qatar', 'MEP Solutions', 'Electrical Contractors'],
      icon: <FaBolt />
    },
    {
      id: 2,
      title: 'Expert Plumbers Qatar: Professional Plumbing Contractors & 24/7 Support',
      excerpt: 'Certified plumbers providing professional plumbing services, manpower supply, emergency repairs, and complete subcontracting.',
      date: 'January 16, 2025',
      category: 'Plumbers',
      slug: 'plumbers-qatar',
      keywords: ['Plumbers Qatar', 'Plumbing Services', 'Professional Contractors'],
      icon: <FaWater />
    },
    {
      id: 3,
      title: 'Professional Masons & Laborers Qatar: Expert Construction Manpower',
      excerpt: 'Skilled masons and laborers for concrete work, brickwork, and complete construction project support.',
      date: 'January 17, 2025',
      category: 'Masons',
      slug: 'masons-laborers-qatar',
      keywords: ['Masons Qatar', 'Construction Labor', 'Skilled Workers'],
      icon: <FaHammer />
    },
    {
      id: 4,
      title: 'Certified Welders Qatar: Expert Welding Services & Structural Steel Work',
      excerpt: 'Professional welders providing structural steel welding, pipe welding, and certified welding subcontracting services.',
      date: 'January 18, 2025',
      category: 'Welders',
      slug: 'welders-qatar',
      keywords: ['Welders Qatar', 'Welding Services', 'Structural Steel'],
      icon: <FaFire />
    },
    {
      id: 5,
      title: 'HVAC Specialists Qatar: Professional Air Conditioning & MEP Services',
      excerpt: 'Expert HVAC technicians providing air conditioning installation, ductwork design, and MEP integration for all project types.',
      date: 'January 19, 2025',
      category: 'HVAC',
      slug: 'hvac-specialists-qatar',
      keywords: ['HVAC Qatar', 'Air Conditioning', 'MEP Services'],
      icon: <FaWind />
    },
    {
      id: 6,
      title: 'Professional Painters Qatar: Expert Painting Services & Contractors',
      excerpt: 'Skilled painters providing residential, commercial, and industrial painting services with professional finishes.',
      date: 'January 20, 2025',
      category: 'Painters',
      slug: 'painters-qatar',
      keywords: ['Painters Qatar', 'Painting Services', 'Professional Contractors'],
      icon: <FaPaintBrush />
    },
    {
      id: 7,
      title: 'Waterproofing & Epoxy Services Qatar: Expert Protection & Coatings',
      excerpt: 'Professional waterproofing and epoxy contractors providing basement protection, roof waterproofing, and industrial coatings.',
      date: 'January 21, 2025',
      category: 'Waterproofing',
      slug: 'waterproofing-epoxy-qatar',
      keywords: ['Waterproofing Qatar', 'Epoxy Coating', 'Protective Services'],
      icon: <FaShieldAlt />
    },
    {
      id: 8,
      title: 'ISO Certified Construction Safety & Rapid Manpower Mobilization in Qatar: The Gold Standard',
      excerpt: 'Deep-dive into Abraj Al Dhafna\'s ISO certified safety protocols, HSE compliance, and vertically-controlled fleet logistics for rapid workforce deployment in Doha & Lusail.',
      date: 'May 13, 2026',
      category: 'Safety & Logistics',
      slug: 'iso-safety-manpower-qatar',
      keywords: ['Safety Standards Qatar', 'ISO Certified Contractor', 'Mobilization Logistics', 'HSE Compliance'],
      icon: <FaShieldAlt />
    }
  ];

  const filteredBlogs = blogs.filter(blog =>
    blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    blog.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
    blog.keywords.some(keyword => keyword.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    console.log('Newsletter signup:', email);
    setEmail('');
  };

  return (
    <>
      <Helmet>
        <title>Blog | Abraj Al Dhafna | Construction Manpower & Skilled Labor Insights Qatar</title>
        <meta name="description" content="Read our latest blog posts about construction manpower supply, skilled labor solutions, electricians, plumbers, painters, and professional services in Qatar." />
        <meta name="keywords" content="construction blog, manpower supply Qatar, skilled labor articles, electricians Doha, plumbers Qatar, painters, construction tips" />
        <meta property="og:title" content="Blog | Abraj Al Dhafna | Construction Insights" />
        <meta property="og:description" content="Latest articles about construction manpower and professional services in Qatar" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="blog-index-page">
        {/* Hero Section */}
        
        <section className="blog-hero py-20 bg-primary-blue">
          <div className="container">
            {/* <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center"
            >
              <h1 className="blog-hero-title text-white mb-6">
                Insights & <span className="text-secondary-gold">Expertise</span>
              </h1>
              <p className="blog-hero-subtitle text-white mb-8">
                Learn about construction manpower, skilled labor solutions, and professional services in Qatar
              </p> */}
              
              {/* Search */}
              {/* <div className="blog-search-container">
                <input
                  type="text"
                  placeholder="Search articles by topic, service, or keywords..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="blog-search-input"
                />
                <FaArrowRight className="search-icon" />
              </div> */}
            {/* </motion.div> */}
            <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.8 }}
                    className="text-center"
                  >
                    <h1 className="contact-hero-title text-white mb-6">
                Insights & <span className="text-secondary-gold">Expertise</span>
                    </h1>
                    <p className="contact-hero-subtitle text-white">
                Learn about construction manpower, skilled labor solutions, and professional services in Qatar
                    </p>
                  </motion.div>
          </div>
        </section>

        {/* Blog Grid */}
        <section className="blog-grid-section py-20">
          <div className="container">
            {filteredBlogs.length > 0 ? (
              <div className="blog-grid">
                {filteredBlogs.map((blog, index) => (
                  <motion.article
                    key={blog.id}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    whileHover={{ y: -10, boxShadow: '0 12px 24px rgba(0,0,0,0.15)' }}
                    className="blog-card"
                  >
                    <div className="blog-card-icon">
                      {blog.icon}
                    </div>
                    <h2 className="blog-card-title">{blog.title}</h2>
                    <p className="blog-card-excerpt">{blog.excerpt}</p>
                    
                    <div className="blog-card-meta">
                      <span className="blog-date"><FaCalendar /> {blog.date}</span>
                      <span className="blog-category">{blog.category}</span>
                    </div>

                    <div className="blog-keywords">
                      {blog.keywords.map((keyword, idx) => (
                        <span key={idx} className="keyword-badge">{keyword}</span>
                      ))}
                    </div>

                    <Link to={`/blog/${blog.slug}`} className="blog-read-more">
                      Read More <FaArrowRight />
                    </Link>
                  </motion.article>
                ))}
              </div>
            ) : (
              <div className="no-results text-center py-20">
                <p className="text-lg text-gray-600">No articles found matching your search. Try different keywords.</p>
              </div>
            )}
          </div>
        </section>

        {/* Newsletter Section */}
        {/* <section className="newsletter-section py-20 bg-light-gray">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="newsletter-content"
            >
              <h2 className="section-title mb-6">
                Stay Updated with <span className="text-primary-blue">Latest Insights</span>
              </h2>
              <p className="section-subtitle mb-8">
                Subscribe to our newsletter for the latest articles about construction manpower, skilled labor solutions, and industry expertise.
              </p>
              
              <form onSubmit={handleNewsletterSubmit} className="newsletter-form">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="newsletter-input"
                />
                <motion.button
                  type="submit"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="newsletter-button"
                >
                  Subscribe
                </motion.button>
              </form>
            </motion.div>
          </div>
        </section> */}

        {/* CTA Section */}
        <CallToAction />
        {/* <section className="cta-section py-20 bg-primary-blue">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <h2 className="cta-title text-white mb-6">
                Ready to Get Professional <span className="text-secondary-gold">Services?</span>
              </h2>
              <p className="cta-subtitle text-white mb-8">
                Contact us today for skilled manpower, professional contractors, and expert solutions for your project.
              </p>
              <Link to="/contact" className="btn btn-gold">
                Contact Us Now <FaArrowRight />
              </Link>
            </motion.div>
          </div>
        </section> */}
      </div>
    </>
  );
}

export default BlogIndex;
